import { Bell } from "lucide-react";
import UseCasePage from "@/components/site/UseCasePage";

const UseCaseTransactionalAlerts = () => (
  <UseCasePage
    slug="transactional-alerts"
    metaTitle="Transactional SMS Alerts for Business | Yootelco"
    metaDescription="Send real-time transactional SMS alerts for orders, payments, and account activity, delivered with carrier-grade reliability."
    title="The Message Your Customer Was Waiting For."
    heroDescription="Order confirmed. Package shipped. Payment received. Yootelco delivers time-sensitive business alerts instantly so your customers stay informed and your support team stays quiet."
    whatItIs="Transactional alerts are messages triggered by customer actions or account events. They include order confirmations, shipping notifications, appointment reminders, and password resets  communications customers expect and need."
    heroIcon={Bell}
    challenges={[
      "Customers not receiving order confirmations",
      "Delayed shipping notifications causing missed deliveries",
      "No visibility into which messages delivered",
      "International customers unreachable",
      "Support burden from missed notifications",
    ]}
    solutions={[
      "High-priority routing for transactional messages",
      "Real-time event-triggered sending",
      "Comprehensive delivery reports and analytics",
      "Global coverage to 200+ countries",
      "Automatic retries and failure notifications",
    ]}
    benefits={[
      { title: "Order Confirmations", description: "Instant SMS the moment a purchase is made. Reduces anxiety, lowers support contacts, and builds immediate trust in your platform." },
      { title: "Shipping & Delivery Updates", description: "Keep customers informed at every stage  dispatched, out for delivery, delivered. Proactive updates mean fewer support contacts." },
      { title: "Payment & Invoice Alerts", description: "Instant notification when a payment is processed, invoice issued, or subscription renews so customers are never surprised." },
      { title: "Appointment Reminders", description: "Reduce no-shows with automated SMS reminders sent at the right time before every appointment." },
      { title: "Account Activity Notifications", description: "Password changes, login alerts, profile updates  keep users informed so they can act immediately if something looks wrong." },
      { title: "High Volume, High Reliability", description: "Whether you send a hundred messages or a million  same reliability and delivery speed at any volume." },
    ]}
    audiences={[
      "E-commerce platforms sending order updates",
      "Logistics companies with delivery notifications",
      "Service businesses with appointment reminders",
      "Any business with customer-triggered notifications",
    ]}
    faqs={[
      { question: "What are transactional SMS messages?", answer: "Transactional SMS are automated texts triggered by a customer action, like a purchase, payment, shipment, or account change. They are informational, time-sensitive, and expected by the recipient." },
      { question: "What is the difference between transactional and promotional SMS?", answer: "Transactional SMS contains information the customer needs, like an order confirmation. Promotional SMS is marketing content sent to drive a purchase or engagement." },
      { question: "Which industries use transactional SMS?", answer: "E-commerce, logistics, banking, healthcare, travel, and any business that needs to notify customers about orders, appointments, payments, or account activity." },
      { question: "How fast are transactional SMS messages delivered?", answer: "Yootelco delivers via direct carrier routes, messages arrive within seconds of being triggered." },
      { question: "Can transactional SMS be sent at high volume?", answer: "Yes. Our infrastructure handles enterprise-scale volumes during peak periods without performance drops." },
      { question: "How do I get started?", answer: "Contact our team via the contact page. We respond within 24 hours with pricing and an onboarding plan." },
    ]}    
    ctaTagline="Tell us about your transactional messaging needs and we'll show you how Yootelco can deliver alerts at scale."
  />
);

export default UseCaseTransactionalAlerts;
